import { render, staticRenderFns } from "./BrowserBot.vue?vue&type=template&id=b4d94d08&scoped=true&"
import script from "./BrowserBot.vue?vue&type=script&lang=js&"
export * from "./BrowserBot.vue?vue&type=script&lang=js&"
import style0 from "../components/css/Style.css?vue&type=style&index=0&id=b4d94d08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d94d08",
  null
  
)

export default component.exports